
import http, { Response } from '@utils/http/http';
import type { agreementParams,agreementListParams } from './types';
import { IResult } from '@/api/baseTypes';

// 协议列表
export const agreementListApi = (param: agreementListParams):Promise<IResult> => {
  return http.post('/tfshop/merchant/agreement/list',{param})
};

// 协议内容
export const agreementInfoApi = (param:agreementParams):Promise<IResult> => {
  return http.post('/tfshop/merchant/agreement/info',{param})
}